<template>
    <div class="subscribe-component">
        <div class="row justify-content-center">

            <div class="col-md-4">
                <div class="card">
                    <div class="card-body">
                        <h3>£{{ price }}</h3>

                        <hr>

                        <ul>
                            <li>2 new courses dropped every month</li>
                            <li>Unlimited access to entire catalogue</li>
                            <li>In-depth PDF learning materials</li>
                            <li>Access to interactive <a href="/stage">Virtuoso Stage</a> events</li>
                            <li>Monthly exclusive partner benefits</li>
                            <li>Your membership gives a schoolchild free access</li>
                        </ul>

                        <template v-if="hasPaymentMethod">
                            <p>
                                You will be charged £{{ price }} on your card ending {{  paymentMethod.last4 }}.
                                <a :href="'/account/update-payment-method?redirect='+ url">Update payment method</a>.
                            </p>

                            <b-button variant="success" :disabled="isBusy" @click="handlePurchase()" class="btn-block">Buy</b-button>
                        </template>
                        <template v-else>
                            <a :href="'/account/update-payment-method?redirect='+ url" class="btn btn-success btn-block">Continue</a>
                        </template>
                    </div>
                </div>
            </div>
            
        </div>
        
        <!--
        <div class="row mt-3">
            <div class="col">
                <div class="terms text-white text-center">
                    <small>
                        Attendance of our Virtuoso Stage sessions is charged on top of your membership.
                    </small>
                </div>
            </div>
        </div>
        -->
    </div>
</template>

<script>
    import { globalEventFire } from '../tracker.js';
    
    export default {
        props: {
            price: {
                type: Number,
                required: false,
            },
            months: {
                type: Number,
                required: false,
            },
            url: {
                type: String,
                required: true,
            },
            hasPaymentMethod: {
                type: Boolean,
                required: true,
            },
            paymentMethod: {
                type: Object,
                required: false,
            },
        },

        data() {
            return {
                stripeAPIToken: document.querySelector('meta[name="stripe-key"]').getAttribute('content'),
                stripe: '',
                isBusy: false,
                error: false,
                hasError: false,
                defaultBtnText: 'Buy',
                btnText: 'Buy',
            }
        },

        mounted() {
            this.btnText = this.defaultBtnText;

            this.includeStripe('js.stripe.com/v3/', function(){
                this.configureStripe();
            }.bind(this) );
        },

        methods: {
            includeStripe( URL, callback ){
                let documentTag = document, tag = 'script',
                    object = documentTag.createElement(tag),
                    scriptTag = documentTag.getElementsByTagName(tag)[0];
                object.src = '//' + URL;
                if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
                scriptTag.parentNode.insertBefore(object, scriptTag);
            },
    
            /*
                Configures Stripe by setting up the elements and 
                creating the card element.
            */
            configureStripe() {
                this.stripe = Stripe( this.stripeAPIToken );
            },

            handlePurchase() {
                this.isBusy = true;
                this.btnText = 'Please wait...';
                this.hasError = false;

                axios.post('/api/giftcards/pay')
                    .then((response) => {
                        if(response.data.success) {
                            this.successfulPaymentRedirect(response.data.metadata.giftcard_id ?? 0);
                        }

                        if(response.data.error) {
                            this.hasError = true;
                            this.error = response.data.error;
                            this.isBusy = false;
                        }

                        if(response.data.status) {
                            let payment_intent = response.data;                            

                            if (payment_intent) {
                                const { client_secret, status } = payment_intent;
                                if (status === 'requires_action') {
                                    this.stripe.confirmCardPayment(client_secret).then((result) => {
                                        if (result.error) {
                                            // Display error message in your UI.
                                            // The card was declined (i.e. insufficient funds, card has expired, etc)
                                            this.hasError = true;
                                            this.error = result.error.message;
                                            this.isBusy = false;
                                        } else {
                                            // Redirect after a timeout to give the webhook time to run
                                            this.successfulPaymentRedirect(response.data.metadata.giftcard_id ?? 0);
                                        }
                                    });
                                } else if(status === 'succeeded') {
                                    this.successfulPaymentRedirect(response.data.metadata.giftcard_id ?? 0);
                                } else {
                                    this.hasError = true;
                                    this.error = 'An error was encountered.  Error code #FAS2135';
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.hasError = true;
                        this.error = 'An unexpected error occured.';
                        this.isBusy = false;
                    });
            },

            // When payment is successful redirect after firing analytics
            successfulPaymentRedirect(enrolment_id) {
                // Fire success
                this.fireAnalytics(enrolment_id);

                setTimeout(() => {
                    location.href = '/gift-cards/purchase/success';
                }, 1500);
            },

            // Fire analytics
            fireAnalytics(enrolment_id) {
                globalEventFire('Purchase', 'GiftCard', {
                    'category': 'GiftCard', 
                    'name': 'Gift Card - 6 months',
                    'item_id': 0,
                    'num_items': 1,
                    'transaction_id': enrolment_id ?? 0,
                    'amount': this.price,
                });
            }
        }
    }
</script>